<template>
    <div class="results-loading-skeleton">
        <SearchTitleSkeleton />
        <FakeProfileCardsRow skeleton class="results-loading-skeleton__cards" />
    </div>
</template>

<script setup lang="ts">
    import FakeProfileCardsRow from './FakeProfileCardsRow.vue';
    import SearchTitleSkeleton from '../search-titles/SearchTitleSkeleton.vue';
</script>

<style lang="scss">
    .results-loading-skeleton {
        &__cards {
            margin-top: var(--joy-core-spacing-6);
        }
    }
</style>
